import axios from "axios";
import { api } from "../config";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

const getAuthUser = () => {
  if (typeof window === "undefined") return null;

  const json =
    localStorage.getItem("authUser") ||
    sessionStorage.getItem("authUser");

  try {
    return json ? JSON.parse(json) : null;
  } catch (error) {
    return null;
  }
};

const saveAuthUser = (user) => {
  if (typeof window === "undefined") return;

  const json = JSON.stringify(user);

  // Clear old login data
  sessionStorage.removeItem("authUser");

  // Keep login persistent in this browser
  localStorage.setItem("authUser", json);
};

const clearAuthUser = () => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem("authUser");
  localStorage.removeItem("authUser");
};

const token = getAuthUser()?.token || null;
if (token) axios.defaults.headers.common["Authorization"] = "Bearer " + token;

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },

  function (error) {

    const status = error.response?.status;

    let message;

    switch (status) {

      case 500:
        message = "Internal Server Error";
        break;

      case 401:
        message = "Invalid credentials";
        break;

      case 404:
        message =
          "Sorry! the data you are looking for could not be found";
        break;

      default:
        message = error.message || "Something went wrong";
    }

    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  return getAuthUser();
};

export { APIClient, setAuthorization, getLoggedinUser, getAuthUser, saveAuthUser, clearAuthUser };